export default "__VITE_ASSET__7fdb02f5__"